import React, { useState, useEffect } from "react";
import "./App.css";
import Header from "./Header";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "./Loader";
import backgroundImage from "./army_college.png";
import bannerImage from "./Form Banner.png";

const Form = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    donor_name: "",
    mobile_number: "",
    transaction_amount: "",
    email: "",
    donor_address: "",
    toggle: "",
    pan_number: "",
  });

  const [errors, setErrors] = useState({});
  const [activeToastId, setActiveToastId] = useState(null);

  const validateForm = () => {
    const newErrors = {};

    // Donor Name validation

    if (!formData.donor_name.trim()) {
      newErrors.donor_name = "Donor name is required";
    } else if (!/^[a-zA-Z\s]+$/.test(formData.donor_name)) {
      newErrors.donor_name =
        "Name should not contain numbers or special characters";
    }
    if (!formData.donor_address.trim()) {
      newErrors.donor_address = "Address is required";
    } else if (!/^[a-zA-Z0-9,-\s]+$/.test(formData.donor_address)) {
      newErrors.donor_address = "Address should not contain special characters";
    }

    // Mobile Number validation
    if (!formData.mobile_number.trim()) {
      newErrors.mobile_number = "Mobile number is required";
    } else if (!/^[0-9]{10}$/.test(formData.mobile_number)) {
      newErrors.mobile_number = "Please enter a valid 10-digit mobile number";
    }

    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(formData.email)
    ) {
      newErrors.email = "Invalid email format";
    }

    // transaction_amount validation
    if (!formData.transaction_amount) {
      newErrors.transaction_amount = "Amount is required";
    } else if (formData.transaction_amount <= 0) {
      newErrors.transaction_amount = "Amount is required";
    }

    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update form data
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Validate the changed field
    const fieldErrors = validateField(name, value);

    // Update errors state: remove error if field is valid, otherwise set the error
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (Object.keys(fieldErrors).length === 0) {
        delete updatedErrors[name]; // Remove error if field is valid
      } else {
        updatedErrors[name] = fieldErrors[name]; // Set error if field is invalid
      }
      return updatedErrors;
    });
  };

  const validateField = (name, value, formData = {}) => {
    const newErrors = {};

    switch (name) {
      case "donor_name":
        if (!value) {
          newErrors.donor_name = "Donor name is required";
        } else if (!/^[a-zA-Z\s]+$/.test(value)) {
          newErrors.donor_name =
            "Name should not contain numbers or special characters";
        }
        break;

      case "donor_address":
        if (!value) {
          newErrors.donor_address = "Address is required";
        } else if (!/^[a-zA-Z0-9,-\s]+$/.test(value)) {
          newErrors.donor_address =
            "Address should not contain special characters";
        }
        break;

      case "mobile_number":
        if (!value) {
          newErrors.mobile_number = "Mobile number is required";
        } else if (!/^[0-9]{10}$/.test(value)) {
          newErrors.mobile_number =
            "Please enter a valid 10-digit mobile number (digits only)";
        }
        break;

      case "email":
        if (!value.trim()) {
          newErrors.email = "Email is required";
        } else if (
          !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(value)
        ) {
          newErrors.email = "Invalid email format";
        }
        break;

      case "amount":
        const amountValue = Number(value);
        if (isNaN(amountValue)) {
          newErrors.amount = "Please enter a valid amount";
        } else if (amountValue <= 0) {
          newErrors.amount =
            "Donation amount should be greater than or equal to 1";
        }
        break;
      default:
        break;
    }

    return newErrors;
  };

  function generateTransactionId() {
    const now = new Date();
    const year = now.getFullYear().toString().slice(2); // Last 2 digits of the year
    const month = (now.getMonth() + 1).toString().padStart(2, "0"); // Month
    const date = now.getDate().toString().padStart(2, "0"); // Date
    const hours = now.getHours().toString().padStart(2, "0"); // Hours
    const minutes = now.getMinutes().toString().padStart(2, "0"); // Minutes
    const seconds = now.getSeconds().toString().padStart(2, "0"); // Seconds
    const milliseconds = now.getMilliseconds().toString().padStart(3, "0");

    const transactionId = `NDPS${year}${month}${date}${hours}${minutes}${seconds}${milliseconds}`;
    return transactionId;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      // Only show a new toast if no toast is active
      if (!activeToastId || !toast.isActive(activeToastId)) {
        toast.dismiss(); // Clear any existing toasts for safety
        const toastId = toast.error(
          "Please fill all the required details correctly",
          {
            onClose: () => setActiveToastId(null), // Clear toast ID when toast closes
          }
        );
        setActiveToastId(toastId); // Store the new toast ID
      }
      return;
    }
    // Set PAN in sessionStorage
    sessionStorage.setItem("pancard", formData.pan_number);

    // Update toggle based on PAN presence
    const updatedFormData = {
      ...formData,
      toggle: formData.pan_number.trim() ? "1" : "0",
    };

    setIsLoading(true);
    try {
      const transaction_id = generateTransactionId();
      const data = {
        ...updatedFormData,
        transaction_id: transaction_id,
      };

      const formSubmitResponse = await fetch(
        `${process.env.REACT_APP_BASE_URL}/armedforces-api/get-atom-token-id`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (!formSubmitResponse.ok) {
        throw new Error(
          `Submission failed with status: ${formSubmitResponse.status}`
        );
      }

      const submitResult = await formSubmitResponse.json();

      sessionStorage.setItem("donorName", formData.donor_name);

      window.openPay(
        submitResult.tokenData.atomTokenId,
        submitResult.merchant_id,
        formData.email,
        formData.mobile_number
      );

      setIsLoading(false);
    } catch (error) {
      console.error("Error:", error);
      // Only show error toast if no toast is active
      if (!activeToastId || !toast.isActive(activeToastId)) {
        toast.dismiss(); // Clear any existing toasts
        const toastId = toast.error("An error occurred during submission", {
          onClose: () => setActiveToastId(null), // Clear toast ID when toast closes
        });
        setActiveToastId(toastId); // Store the new toast ID
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="donation-wrapper"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="donation-card">
        <div className="header-section">
          <img
            src={bannerImage}
            alt="Ministry of Defence Header"
            className="banner-image"
          />
        </div>

        <h2 className="form-title">
          Donation Form - Armed Forces Battle Casualties Welfare Fund
        </h2>

        <form className="donation-form" onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-group">
              <label htmlFor="donor_name">Donor Name *</label>
              <input
                type="text"
                id="donor_name"
                name="donor_name"
                value={formData.donor_name}
                onChange={handleChange}
                placeholder="Enter donor name"
                required
              />
              {errors.donor_name && (
                <span className="error-message">{errors.donor_name}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="mobile_number">Mobile *</label>
              <input
                type="tel"
                id="mobile_number"
                name="mobile_number"
                value={formData.mobile_number}
                onChange={handleChange}
                placeholder="Enter valid mobile number"
                pattern="[0-9]{10}"
                required
              />
              {errors.mobile_number && (
                <span className="error-message">{errors.mobile_number}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter valid email"
                required
              />
              {errors.email && (
                <span className="error-message">{errors.email}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="donor_address">Donor Address *</label>
              <input
                type="text"
                id="donor_address"
                name="donor_address"
                value={formData.donor_address}
                onChange={handleChange}
                placeholder="Enter address"
                required
              />
              {errors.donor_address && (
                <span className="error-message">{errors.donor_address}</span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="transaction_amount">Amount to be Paid *</label>
              <input
                type="number"
                id="transaction_amount"
                name="transaction_amount"
                value={formData.transaction_amount}
                onChange={handleChange}
                placeholder="Enter donation amount"
                min="0.01"
                step="any"
                required
              />

              {errors.transaction_amount && (
                <span className="error-message">
                  {errors.transaction_amount}
                </span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="pan_number">PAN Number</label>
              <input
                type="text"
                id="pan_number"
                name="pan_number"
                value={formData.pan_number}
                onChange={handleChange}
                placeholder="Enter valid PAN (e.g. ABCDE1234F)"
                pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}"
                title="Enter a valid 10-character PAN (e.g. ABCDE1234F)"
              />
              {errors.pan_number && (
                <span className="error-message">{errors.pan_number}</span>
              )}
            </div>

            <div className="form-group full-width">
              <button type="submit" className="submit-button">
                Submit
              </button>
            </div>
            <div className="poweredby-wrapper">
              <span className="poweredby-text">powered by</span>
              <img
                src="https://payformservices.nttdatapay.com/logos/armedforces/adaptis-dark.webp"
                alt="Logo"
                className="poweredby-logo"
              />
            </div>
          </div>
        </form>
      </div>
      <ToastContainer limit={1} autoClose={3000} />
      {isLoading && <Loader />}
    </div>
  );
};

export default Form;

